<!--
     <FilterProcess
       :filters="QFilters"
       @update="handle_update(QFilters)"
     />
-->

<template>
    <v-menu
    ref="activator"
    v-model="menu_open"
    offset-y
    min-width="290px"
    dense
    :close-on-content-click="false"
    :disabled="disabled"
    @input="pull_filters"
  >
  <template v-slot:activator="{ on }">
    <slot 
      name="activator" 
      :on="on" 
      :props="props" 
      :text="selection.length > 0 ? selection.length +' '+ $vuetify.lang.translator('filters.processes.processes_selected') : ''" 
      :placeholder="processes_selected_text">
      <v-btn
        v-if="!is_mobile"
        @click.stop="pull_filters();"
        v-on="on"
        class="qmkey-btn-process-filter"
        :class="[filtered_count ? 'qmkey-btn-process-filter-active' : '',
          props.activator_class ? props.activator_class : ''
        ]"
      >
        <v-row  
          no-gutters
          align="center"
          justify="start"
          class="mr-0 pr-0"
          style="height: 36px"
        >
          <v-col
            cols="auto"
            class="mr-4 text-left"
            tile
            outlined
            style="min-width: 180px"
          >
            {{ processes_selected_text }}
          </v-col>
          <v-col
            cols="auto"
            tile
            class="mr-0 border-right"
            style="height: 36px"
          >
          </v-col>
          <v-col cols="auto" class="ma-0" tile outlined>
            <v-icon right class="icon-large">mdi-chevron-down</v-icon>
          </v-col>
        </v-row>
      </v-btn>
      <v-btn
        v-else
        @click.stop="pull_filters();"
        icon
        small
        v-on="on"
        :class="props.activator_class ? props.activator_class : ''"
      >
      </v-btn>
    </slot>
  </template>  
    <div>
      <v-card >
        <v-card-text >
          <div v-if="selection.length > 0" style="max-width : 100%" persistent-hint>
            <div
              v-if="selection.length < 3"
            >
              <v-chip
                v-for="item in selection"
                :key="item.id"
                color="primary"
                class="mr-2"
              >
                {{ item.name }}
              </v-chip>
            </div>
            <div
              v-else
              class="qmkey-generic-process-filter-selection-text"
            >
              {{ selection.length +' '+ $vuetify.lang.translator('filters.processes.processes_selected') }}
            </div>
          </div>
          <div>
            <v-text-field
              v-model="search_text"
              clearable
              color="primary"
              :label="$vuetify.lang.translator('search_text')"
              class="pl-4 pr-4"
            ></v-text-field>
          </div>
          <v-treeview
            v-model="selection"
            dense
            :items="items_tree"
            :search="search_text"
            return-object
            selection-type="independent"
            class="qmkey-filter-content"
          >
            <template v-slot:prepend="{item, selected, active}">
              <v-btn
                icon
                @click="manage_active(item)"
                :class="selected ? 'accent--text' : ''"
              >
                <v-icon medium> {{ (selected ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline') }}</v-icon>
              </v-btn>
          </template>
          </v-treeview>
        </v-card-text>
        <v-card-actions class="qmkey-modal-dialog-card-actions">
          <v-spacer></v-spacer>
          <v-btn 
            class="qmkey-modal-dialog-button-secundary"
            text 
            color="primary"
            small
            @click="clear"
          >
          {{ $vuetify.lang.translator('dialog.clear') }}
          </v-btn>
          <v-btn 
            class="qmkey-modal-dialog-button-submit"
            text 
            small
            @click="trigger_update"
          >
            {{ $vuetify.lang.translator('dialog.send') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
</v-menu>
</template>

<style lang="scss">
 @import '@/sass/explorer.scss';

 .filterprocess-cont {
   background-color: white;
 }

 .filterprocess-header {
   display: flex;
   gap: 10px;
   align-items: center;
 }

 .qmkey-filter-content {
  overflow-y: scroll;
  max-height: 50vh;
 }
</style>

<script>
 import { mapState, mapGetters } from 'vuex'
 import ProcessMenuItem from '@/components/explorer/ProcessMenuItem'
 import ResponsiveMenuDialog from '@/components/ResponsiveMenuDialog'
 import QTree from '@/utils/QTree'
 import { QFilters, get_qfilter } from '@/qunit/filters';
 
 export default {
   name: 'FilterProcess',

   components: {
     ResponsiveMenuDialog,
     ProcessMenuItem,
   },

   props: {
     disabled: {
       type: Boolean,
       default: false,
     },
     filters: {required: true},
     is_mobile: {type: Boolean, default: false},
     props: {default: () => ({})},
   },

   data: () => ({
     menu_open: false,
     search_text: '',
     selection: [],
   }),

   computed: {
     ...mapState([
       'allProcesses',
       'filterProcesses',
       'qcentro'
     ]),
     ...mapGetters(['user', 'centro_data']),
    //  ...mapGetters(['centro_data'])

     filtered_count() {
       return this.selection.length > 0;
     },

     processes_selected_text() {
       // TODO: LluisE doesn't like that the code depends on filterProcesses
       let text = this.$vuetify.lang.translator('filters.processes.process');
       if (this.filterProcesses && this.filterProcesses.length > 0) {
         if (this.filterProcesses.length > 1) {
           text = this.filterProcesses.length + this.$vuetify.lang.translator('filters.processes.processes_selected');
         } else {
           text = this.filterProcesses[0].name;
         }
       }
       return text;
     },

     processes_tree() {
      // Actually filter all site processes with current user available processes
      //  return new QTree(this.allProcesses);
      //  return new QTree(this.allProcesses.filter(proc => this.user.participant_processes.includes(proc.id)));
      let centro_procs = this.allProcesses.filter(proc => this.centro_data.processes.includes(proc.id) && this.user.participant_processes.includes(proc.id));
      return new QTree(centro_procs);
     },

     items_tree() {
      return Object.values(this.processes_tree.get_array_tree()).sort((p1, p2) => p1.name.localeCompare(p2.name));
     },
   },

   mounted() {
    this.pull_filters()
   },

   methods: {
      manageChildren(check_children, add) {
        for(let child of check_children) {
          const child_pos = this.selection.findIndex(it => it.id == child.id );
          const is_selected = child_pos >= 0;
          if (add && !is_selected) {
            this.selection.push(child);
          } else if (!add && is_selected) {
            this.selection.splice(child_pos,1);
          }
          if (child.children) {
            this.manageChildren(child.children, add);
          }
        }
      },
      manage_active(item) {
        let add_children = true;
        const item_pos = this.selection.findIndex(it => it.id == item.id );
        const is_selected = item_pos >= 0;
        if (!is_selected) {
          this.selection.push(item);
        } else {
          this.selection.splice(item_pos,1);
          add_children = false;
        }
        if (item.children) {
          this.manageChildren(item.children, add_children);
        }
        this.selection = this.selection.toSorted((a,b) => a.id < b.id);
        this.menu = false;
      },

     clear() {
       this.selection = [];
       this.trigger_update();
     },

     trigger_update() {
       const new_ids = this.selection.map(it => it.id).sort();
       if ((this.filters.get_filter_value('processes_ids') || []).join(',') != new_ids.join(',')) {
        let filters = new QFilters();
        filters.set_filter(get_qfilter('processes_ids',new_ids));
         this.$emit('update', filters);
       }
       this.menu_open = false;
     },

     pull_filters() {
      // If selected and filter ids are different, overwrite selected ids
       if ((this.filters.get_filter_value('processes_ids') || []).join(',') != this.selection.map(it => it.id).join(',')) {
        this.selection = (this.filters.get_filter_value('processes_ids') || []).map(proc_id => this.allProcesses.find(it => it.id == proc_id));
       }
     },
      
      get_value() {
        let res = new QFilters();
        const new_ids = this.selection.map(it => it.id).sort();
        res.set_filter(get_qfilter('processes_ids',new_ids));
        return res;
      },
   },

   watch: {
     filters() {
       this.pull_filters();
     },
   },
 }
</script>
